import { render } from "./ActionIcon.vue?vue&type=template&id=796d286d&scoped=true"
import script from "./ActionIcon.vue?vue&type=script&lang=js"
export * from "./ActionIcon.vue?vue&type=script&lang=js"

import "./ActionIcon.vue?vue&type=style&index=0&id=796d286d&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796d286d"]])

export default __exports__